
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

/**
 * 
 */
export class ClientOnboardingApi extends runtime.BaseAPI {

    /**
     * Acknowledge browse profiles onboarding modal
          */
    async acknowledgeBrowseProfilesOnboardingRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/api/client/acknowledge/browse-profiles-onboarding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Acknowledge browse profiles onboarding modal
          */
    async acknowledgeBrowseProfilesOnboarding(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeBrowseProfilesOnboardingRaw(initOverrides);
    }

    /**
     * Tells if should display client browse profiles onboarding
          */
    async getBrowseProfilesOnboardingRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<boolean>({
            path: `/search/api/client/browse-profiles-onboarding`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Tells if should display client browse profiles onboarding
          */
    async getBrowseProfilesOnboarding(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.getBrowseProfilesOnboardingRaw(initOverrides);
        return response._data;
    }

}
